import { render } from "./Logs.vue?vue&type=template&id=3c679e89&scoped=true&ts=true"
import script from "./Logs.vue?vue&type=script&lang=ts"
export * from "./Logs.vue?vue&type=script&lang=ts"

import "./Logs.vue?vue&type=style&index=0&id=3c679e89&scoped=true&lang=css"

import exportComponent from "D:\\Users\\Anton\\Workspaces\\htdocs\\ehop-admin-vueapp\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c679e89"]])

export default __exports__